import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { tokens } from '@hotjar/hotsauce';

const StyledMessage = styled.div`
    color: ${tokens.color.text_disabled};
    font-size: 11px;
    max-width: 500px;
    margin: 30px auto;
    text-align: center;
}`;

export const NpsTrademarkMessage = (): JSX.Element => {
  const { t } = useTranslation();

  return <StyledMessage>{t('common:recordings.nps-trademark-message')}</StyledMessage>;
};
